import { render, staticRenderFns } from "./icon-signatures.vue?vue&type=template&id=49cac2b6"
import script from "./icon-signatures.vue?vue&type=script&lang=js"
export * from "./icon-signatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports